import { LoadingPage } from '@/components/ui/loading';
import { useAuditLogsPage } from '../hooks/use-audit-logs-page';
import { AuditLogsView } from './audit-logs-view';

export function AuditLogsPage() {
  const state = useAuditLogsPage();
  if (state.loading && state.logs.length === 0) return <LoadingPage />;
  return <AuditLogsView state={state} />;
}
